/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/run.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Hint for UI rendering of the value.
 *
 *  - UNSPECIFIED: Default. No special rendering.
 *  - URL: Render the value as a hyperlink.
 * @export
 */
export const MetadataValueRenderType = {
  UNSPECIFIED: 'UNSPECIFIED',
  URL: 'URL',
} as const;
export type MetadataValueRenderType =
  (typeof MetadataValueRenderType)[keyof typeof MetadataValueRenderType];

export function instanceOfMetadataValueRenderType(value: any): boolean {
  for (const key in MetadataValueRenderType) {
    if (Object.prototype.hasOwnProperty.call(MetadataValueRenderType, key)) {
      if (MetadataValueRenderType[key as keyof typeof MetadataValueRenderType] === value) {
        return true;
      }
    }
  }
  return false;
}

export function MetadataValueRenderTypeFromJSON(json: any): MetadataValueRenderType {
  return MetadataValueRenderTypeFromJSONTyped(json, false);
}

export function MetadataValueRenderTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): MetadataValueRenderType {
  return json as MetadataValueRenderType;
}

export function MetadataValueRenderTypeToJSON(value?: MetadataValueRenderType | null): any {
  return value as any;
}

export function MetadataValueRenderTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): MetadataValueRenderType {
  return value as MetadataValueRenderType;
}
